import React, { useState } from "react";

const LeadForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formUrl =
      "https://docs.google.com/forms/d/e/1FAIpQLSe7vD-tudY5ZmbkrHl3yesjO-ESA-RomACR2Mpr7IGWT_g9dw/formResponse";

    const formBody = new URLSearchParams({
      "entry.911675743": formData.name,
      "entry.752561336": formData.email,
      "entry.1664729276": formData.phone,
    });

    try {
      const response = await fetch(formUrl, {
        method: "POST",
        body: formBody,
        mode: "no-cors",
      });

      alert("✅ Inscrição enviada com sucesso!");
      setFormData({ name: "", email: "", phone: "" });
    } catch (error) {
      console.error("Erro ao enviar:", error);
      alert("❌ Erro ao enviar inscrição. Tente novamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="flex justify-center py-12 bg-transparent relative z-10">
      <div className="bg-[#052A47]/95 border border-yellow-400 shadow-2xl rounded-2xl p-8 max-w-md w-full">
        <h2 className="text-center text-white text-2xl font-extrabold mb-6">
          Reserve sua vaga — é grátis
        </h2>

        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
          <div>
            <label className="text-white text-sm font-semibold mb-1 block">
              Nome completo *
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg bg-[#0B3C64] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
              placeholder="Digite seu nome"
            />
          </div>

          <div>
            <label className="text-white text-sm font-semibold mb-1 block">
              E-mail *
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg bg-[#0B3C64] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
              placeholder="seu@email.com"
            />
          </div>

          <div>
            <label className="text-white text-sm font-semibold mb-1 block">
              Telefone *
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg bg-[#0B3C64] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
              placeholder="(00) 00000-0000"
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className={`mt-4 bg-yellow-400 text-[#052A47] font-bold py-3 rounded-full shadow-lg hover:bg-yellow-500 transition-all duration-300 ${
              isSubmitting ? "opacity-70 cursor-not-allowed" : ""
            }`}
          >
            {isSubmitting
              ? "⏳ Enviando..."
              : "🎯 QUERO PARTICIPAR DA AULA GRATUITA"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default LeadForm;